export default __webpack_public_path__ + "static/media/recordKeepingIcon.c8bdeb81.svg";